import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/Gallery.css";

import lab1 from "../img/gallery1.jpg";
import lab2 from "../img/gallery2.jpg";
import lab3 from "../img/gallery3.jpg";
import class1 from "../img/gallery4.jpg";
import class2 from "../img/gallery5.jpg";
import workshop1 from "../img/gallery6.jpg";
import workshop2 from "../img/gallery1.jpg";

const galleryData = [
  {
    title: "Laboratory",
    images: [lab1, lab2, lab3],
    description: "Fully equipped modern electrical and welding labs.",
  },
  {
    title: "Classrooms",
    images: [class1, class2],
    description: "Spacious and digital classrooms for interactive learning.",
  },
  {
    title: "Workshops",
    images: [workshop1, workshop2],
    description: "Hands-on training in real-world industrial environments.",
  },
];

const Gallery = () => {
  const [selected, setSelected] = useState(null);
  const [activeImage, setActiveImage] = useState(null);

  return (
    <div className="gallery-section py-5">
      <div className="container">
        <h2 className="text-center mb-5 fw-bold text-primary">Our Infrastructure Gallery</h2>

        <div className="row g-4">
          {galleryData.map((item, index) => (
            <div className="col-md-4" key={index}>
              <div
                className="gallery-card shadow-sm"
                onClick={() => setSelected(item)}
              >
                <img
                  src={item.images[0]}
                  alt={item.title}
                  className="img-fluid rounded gallery-thumb"
                />
                <div className="gallery-overlay">
                  <h5>{item.title}</h5>
                  <p>{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* ===== Modal / Lightbox ===== */}
        {selected && (
          <div className="lightbox" onClick={() => setSelected(null)}>
            <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
              <button
                className="btn-close btn-close-white position-absolute top-0 end-0 m-3"
                onClick={() => setSelected(null)}
              ></button>
              <h4 className="text-center text-light mb-3">{selected.title}</h4>

              <div className="row g-3">
                {selected.images.map((img, i) => (
                  <div className="col-md-4" key={i}>
                    <img
                      src={img}
                      alt="Lab view"
                      className="img-fluid rounded lightbox-img"
                      onClick={() => setActiveImage(img)}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* ===== Fullscreen Image Viewer ===== */}
        {activeImage && (
          <div className="fullscreen-viewer" onClick={() => setActiveImage(null)}>
            <img src={activeImage} alt="Full view" className="fullscreen-img" />
          </div>
        )}
      </div>
    </div>
  );
};

export default Gallery;
